import { SelectItemAgreementTable } from '@retail/purchase-agreements/components';
import { useFetchAgreementPricesForItem } from '@retail/purchase-agreements/data-access';
import { ItemAgreementPrices } from '@retail/purchase-agreements/types';
import { useCallback, useMemo, useState } from 'react';

interface Props {
  assortmentId: number;
  supplierItemId: number;
  selectAgreement: (agreement?: ItemAgreementPrices) => void;
}

export function SelectItemAgreements({ assortmentId, supplierItemId, selectAgreement }: Props) {
  const { data: itemAgreementsPageDto = [] } = useFetchAgreementPricesForItem({
    assortmentId,
    supplierItemId,
  });

  const itemAgreements = useMemo(
    () => itemAgreementsPageDto.map(ItemAgreementPrices.fromDto),
    [itemAgreementsPageDto]
  );

  const [checkedAgreement, setCheckedAgreement] = useState<ItemAgreementPrices | undefined>();
  const handleCheckAgreement = useCallback(
    (agreement: ItemAgreementPrices) => {
      setCheckedAgreement(agreement);
      selectAgreement(agreement);
    },
    [selectAgreement]
  );

  return (
    <SelectItemAgreementTable
      itemAgreements={itemAgreements}
      selectedAgreement={checkedAgreement}
      selectAgreement={handleCheckAgreement}
    />
  );
}
